import React, { useEffect } from "react";

interface Props {
  badge: string;
  styles?: any;
}

export enum BADGES {
  none = 'none',
  level_one = 'level_one',
  level_two = 'level_two',
  level_three = 'level_three',
  level_four = 'level_four',
  level_five = 'level_five',
  level_goat = 'level_goat',
};

const Badges = ({
  badge,
  styles = null
}: Props) => {
  const badges: any = {
    [BADGES.level_one]: require('../assets/image/badges/aquamarine_gem.png'),
    [BADGES.level_two]: require('../assets/image/badges/sapphire_gem.png'),
    [BADGES.level_three]: require('../assets/image/badges/emerald_gem.png'),
    [BADGES.level_four]: require('../assets/image/badges/amethyst_gem.png'),
    [BADGES.level_five]: require('../assets/image/badges/topaz_gem.png'),
    [BADGES.level_goat]: require('../assets/image/badges/ruby_gem.png'),
    [BADGES.none]: ''
  };  

  return (
    <>
      { badge !== BADGES.none && <img src={badges[badge || BADGES.none]} alt="" style={styles ? styles : { width: '50px', height: '50px' }}/>}
    </>
  );
};

export default Badges;